/**
 * useOfficeReady.ts
 * Awaits Office.initialize and sets global readiness state.
 * Must be used in the root App component.
 */

import { useEffect } from 'react';
import { useAppStore } from '@store/appStore';

export function useOfficeReady(): boolean {
  const setOfficeReady = useAppStore((s) => s.setOfficeReady);
  const isOfficeReady = useAppStore((s) => s.isOfficeReady);

  useEffect(() => {
    // Office.onReady is preferred over Office.initialize for Office.js 1.1+.
    // Teacher authentication is handled separately via email/password login
    // (useTeacherAuth), not anonymous sign-in, so teacher data persists.
    Office.onReady((info) => {
      if (info.host !== Office.HostType.PowerPoint) {
        console.warn('[GuroHub] Not running in PowerPoint. Some features will be unavailable.');
      }
      setOfficeReady(true);
    });
  }, [setOfficeReady]);

  return isOfficeReady;
}
